import React, { FC, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import { BUYER_SUPPLIER_ADMIN_ROLES, hasRequiredRole } from '../roles/roles';
import {
	PERMISSION_NAMES,
	isUserAllowedToAccess,
	isUserManagedBySupplier,
} from '../../utils/AuthUtils';
import OverviewShell from '../overview_shell/OverviewShell';

require('./LocationsOverviewPage.less');

const LocationsOverviewPage: FC<any> = ({
	userType,
	history,
	companyConfig,
	currentUser,
	childRoutes,
}): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => {
			history.push(`/${userType}/locations/overview/${key}`);
		},
		[history, userType]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const isAdmin = useMemo(
		() => hasRequiredRole(currentUser.roles, BUYER_SUPPLIER_ADMIN_ROLES),
		[currentUser.roles]
	);

	const templatesVisible = useMemo(
		() =>
			isUserAllowedToAccess(currentUser.userType)(
				PERMISSION_NAMES.MODIFY_LOCATION_TYPES,
				companyConfig,
				currentUser.roles
			),
		[companyConfig, currentUser.roles, currentUser.userType]
	);

	const isNotSupplierManaged = useMemo(() => !isUserManagedBySupplier(currentUser), []);
	const tabs = useMemo(() => {
		return [
			{
				key: 'all',
				name: 'All',
			},
			...(templatesVisible && isNotSupplierManaged
				? [
						{
							key: 'templates/overview',
							name: 'Templates',
						},
				  ]
				: []),
			...(isAdmin && isNotSupplierManaged
				? [
						{
							key: 'regions/overview',
							name: 'Regions',
						},
						{
							key: 'brands/overview',
							name: 'Brands',
						},
				  ]
				: []),
		];
	}, [isAdmin, templatesVisible, isNotSupplierManaged]);

	return (
		<>
			<Route
				path={`/${userType}/locations/overview`}
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: `/${userType}/locations/overview/all`,
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Locations"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="locationsPage"
			/>
		</>
	);
};

const mapStateToProps = (state) => ({
	companyConfig: state.company_config.detail,
	currentUser: state.session.currentUser,
});

const ComponentWithoutUserType = withRouter<any, any>(
	connect(mapStateToProps)(LocationsOverviewPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
